// Service page content for Business & Investment Advisory.
// Sourced from docs/research/australian-visa-pathways.md §4.
// Overview level per DECISIONS D-001 (pending a dedicated research pass).
// COMPLIANCE: we prepare, organise, and coordinate; a registered migration
// agent assesses your profile, advises the route, and lodges. No guarantees;
// honest that BIIP is closed and the NIV is highly selective; no unverified
// figures stated as fact.

const businessInvestmentAdvisory = {
  groupSlug: "business-investment",
  slug: "business-investment-advisory",
  title: "Business & Investment Support",
  eyebrow: "Business & Investment",
  intro:
    "Australia's business and investment migration options have changed significantly. The old Business Innovation and Investment Program is closed to new applicants, and the focus has shifted to the National Innovation visa for genuinely exceptional people. We prepare and organise your file and match you with a registered migration agent, who assesses your profile and gives you a clear, honest read on what is actually available now.",

  chips: [
    { label: "BIIP (188/888)", value: "Closed to new applicants" },
    { label: "Current route", value: "National Innovation visa (858)" },
    { label: "Also consider", value: "Skilled or employer-sponsored" },
    { label: "The bar", value: "High and selective" },
  ],

  whoFor: [
    "Business owners, investors, and exceptional professionals exploring Australian options.",
    "Existing 188 holders looking at their pathway to the permanent 888.",
    "People who want a registered migration agent's honest read on whether a business or talent route is realistic.",
  ],

  essentials: [
    {
      title: "The old program is closed",
      detail:
        "The Business Innovation, Investor, and Significant Investor streams stopped taking new Subclass 188 applications. For most new business migrants, this is no longer a live path.",
    },
    {
      title: "Existing applicants continue",
      detail:
        "Applications lodged before the cut-off continue to be processed, and existing 188 holders generally retain a pathway to the permanent 888.",
    },
    {
      title: "The National Innovation visa",
      detail:
        "The Subclass 858 is now the premier route for global experts, high-performing entrepreneurs, researchers, and investors who will benefit Australia. It is permanent on grant.",
    },
    {
      title: "It is invitation-based",
      detail:
        "You submit an Expression of Interest demonstrating internationally recognised, exceptional achievement. If invited, you have a limited window to apply.",
    },
    {
      title: "A genuinely high bar",
      detail:
        "Despite no set investment amount, the National Innovation visa is selective. Exceptional and outstanding is a high standard, and an invitation is never guaranteed.",
    },
    {
      title: "Other routes may fit better",
      detail:
        "For many business people, a skilled or employer-sponsored visa is a more realistic path. A registered migration agent assesses all of them with you.",
    },
  ],

  process: [
    {
      title: "An honest options review",
      detail:
        "A registered migration agent sets out what is open now and whether a business, talent, skilled, or sponsored route is realistic for you.",
    },
    {
      title: "Your profile, assessed by a registered agent",
      detail:
        "For the National Innovation visa, a registered migration agent assesses your achievements against a high bar before you invest time in an Expression of Interest. We organise the evidence they need.",
    },
    {
      title: "Build the case",
      detail:
        "If there is a genuine prospect, we prepare and organise a strong, evidence-led Expression of Interest.",
    },
    {
      title: "Manage the application",
      detail:
        "If invited, we build a complete, submission-ready file, and a registered migration agent lodges it and manages correspondence with the Department.",
    },
    {
      title: "Plan an alternative",
      detail:
        "If a talent route is not realistic, a registered migration agent maps a skilled or employer-sponsored plan, and we prepare the documents for it.",
    },
  ],

  faqs: [
    {
      q: "Can I still apply for the business investor visa?",
      a: "Not as a new applicant. The Business Innovation and Investment Program is closed to new applications. If you already lodged before the cut-off, your application continues, and a registered migration agent can advise on your pathway to the permanent stage.",
    },
    {
      q: "What replaced it?",
      a: "The National Innovation visa (Subclass 858) is now the premier route, aimed at exceptionally talented people, including entrepreneurs, investors, and researchers. It is permanent, but it is selective and invitation-based.",
    },
    {
      q: "Do I need to invest a set amount for the National Innovation visa?",
      a: "No set investment amount is required. It is about demonstrating internationally recognised, exceptional achievement. Honestly, the bar is high, and an invitation is not guaranteed even with a strong case.",
    },
    {
      q: "What if I do not meet that bar?",
      a: "Many business people are better served by a skilled or employer-sponsored visa. A registered migration agent assesses every realistic option and tells you straight which is worth pursuing, and we prepare and organise the file for it.",
    },
  ],

  related: ["skills-in-demand-482", "employer-nomination-186", "skilled-independent-189"],

  lastVerified: "13 July 2026",
};

export default businessInvestmentAdvisory;
